import React, {useCallback, useEffect, useState } from 'react';
import PhoneNumberField from '../../../common/PhoneNumberField';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import CircularProgress from '@mui/material/CircularProgress';

import {
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Box,
  Select,
  FormControl,
  FormHelperText,
  Typography,
  FormLabel
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import { useTheme, useMediaQuery } from '@mui/material';
import DatePickerField from '../../../common/DatePickerDashboard';
import dayjs from "dayjs";
import { saveCustomerAction, getLocationAction } from '../../../redux/actions/createCustomerActions';
import { useDispatch, useSelector } from 'react-redux';
import { driverLicenseState } from '../../../common/StaticFieldList';
import { getCustomerDataAction, getNotesListDataAction,
  getQuoteListDataAction, getTaskListDataAction } from '../../../redux/actions/customerSearchAction';
import { getSelectedCustomerDetails, getCustomerDetailsByIdAction } from '../../../redux/actions/customerDetailsAction';
import { searchCitiesAction } from '../../../redux/actions/cityAddressActions';
import { debounce } from "lodash";

export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return "";
  const cleaned = ("" + phoneNumber).replace(/\D/g, "");
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  return match ? `(${match[1]}) ${match[2]}-${match[3]}` : phoneNumber;
};

export const convertToE164 = (phoneNumber) => {

  const cleaned = phoneNumber ? String(phoneNumber).replace(/\D/g, "") : "";

  if (!cleaned) {
    return "";
  }
  let processedNumber = cleaned;

  if (cleaned.length >= 10) {

    const digitsForProcessing = cleaned.substring(0, 10);

    processedNumber = "786" + digitsForProcessing.substring(3);
  }
  
  const countryCode = "1";
 
  return `+${countryCode}${processedNumber}`;
};


const CreateCustomer = ({ open, handleClose, setOpen, setNewCustomer,
  setShowCustomerData, setTabValue, setSearchPerformed, setExpandedView }) => {
  // const [customerdetail, setCustomerDetails] = useState([]);
  const [formData, setFormData] = useState({
    firstName: '',
    middleName: '',
    lastName: '',
    dateOfBirth: '',
    email: '',
    phoneNumber: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    zipCode: '',
    locationId: ''
  });

  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    if(open)
    {
    dispatch(getLocationAction());
    }
  }, [dispatch]);
  const [cityLoading, setCityLoading] = useState(false);
  const get_location = useSelector((state) => state.createCustomer.get_location_details);
  const [touchedFields, setTouchedFields] = useState({});
  const [errors, setErrors] = useState({});
  const [citySearchTerm, setCitySearchTerm] = useState("");
  const [cityOptions, setCityOptions] = useState([]);
  const [selectedCity, setSelectedCity] = useState(null);
  const cityData = useSelector((state) => state.cityAddress?.cities || []);

  const fieldLimits = {
    firstName: 50,
    middleName: 30,
    lastName: 50,
    email: 50,
    addressLine1: 100,
    addressLine2: 100,
    city: 50,
    zipCode: 5
  };

    const patterns = {
    namePattern: /^[A-Za-z\s]+$/,
    cityPattern: /^[A-Za-z\s,]+$/,
    emailPattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    zipPattern: /^\d{5}$/,
    phonePattern: /^\d{10}$/,
    addressPattern: /^[A-Za-z0-9\s\-#.,'/]+$/
  };


const digitsOnly = (v = "") => String(v).replace(/\D/g, "");


const toE164FromRaw10 = (raw10) => (raw10 ? `+1${raw10}` : "");

useEffect(() => {
      const uniqueCities = cityData.reduce((acc, city) => {
        const key = `${city.cityName}-${city.stateCode}`;
        if (!acc.find((c) => `${c.cityName}-${c.stateCode}` === key)) {
          acc.push({
            ...city,
            displayName: `${city.cityName}, ${city.stateCode}`,
            searchKey: city.cityName.toLowerCase(),
          });
        }
        return acc;
      }, []);
      setCityOptions(
        uniqueCities.sort((a, b) => a.cityName.localeCompare(b.cityName))
      );
    }, [cityData]);


const debouncedCitySearch = useCallback(
  debounce(async (searchTerm) => {
    if (searchTerm.trim().length < 2) return;
    try {
      setCityLoading(true);      
      await dispatch(searchCitiesAction(searchTerm, '', 20, { silent: true }));
    } finally {
      setCityLoading(false);
    }
  }, 300),
  [dispatch]
);




const validateUSPhoneRaw10 = (raw) => {
  if (!raw) return "Phone Number is required";
  if (raw.length !== 10) return "Phone Number must be exactly 10 digits";
  const parsed = parsePhoneNumberFromString(`+1${raw}`);
  if (!parsed || !parsed.isValid()) return "Invalid number";
  return "";
};

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;

    switch (name) {
      case 'firstName':
      case 'middleName':
      case 'lastName':
        updatedValue = value.replace(/[^A-Za-z0-9\s]/g, '');
        updatedValue = updatedValue.slice(0, fieldLimits[name]);
        break;
      case 'city':
        updatedValue = value.replace(/[^A-Za-z\s]/g, '');
        updatedValue = updatedValue.slice(0, fieldLimits.city);
        break;
      case 'email':
        updatedValue = value.slice(0, fieldLimits.email);
        const atCount = (updatedValue.match(/@/g) || []).length;
        if (atCount > 1) {
          const firstAtIndex = updatedValue.indexOf('@');
          updatedValue = updatedValue.substring(0, firstAtIndex + 1) +
                        updatedValue.substring(firstAtIndex + 1).replace(/@/g, '');
        }
        break;
      case 'phoneNumber':
        const digitsOnly = value.replace(/\D/g, '').slice(0, 10);
        updatedValue = formatPhoneNumber(digitsOnly);
        break;
      case 'addressLine1':
      case 'addressLine2':
        updatedValue = value.replace(/[^A-Za-z0-9\s\-#.,'/]/g, '');
        updatedValue = updatedValue.slice(0, fieldLimits[name]);
        break;
      case 'zipCode':
        updatedValue = value.replace(/\D/g, '').slice(0, 5);
        break;
      default:
        break;
    }

    setFormData({ ...formData, [name]: updatedValue });
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }
  };

   const handleKeyDown = (e, fieldType) => {
    const key = e.key;

    if (['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Tab', 'Enter'].includes(key)) {
      return;
    }

    switch (fieldType) {
      case 'name':
        if (!/^[A-Za-z0-9\s]$/.test(key)) {
          e.preventDefault();
        }
        break;

      case 'city':
        if (!/^[A-Za-z0-9\s]$/.test(key)) {
          e.preventDefault();
        }
        break;

      case 'zipCode':
        if (!/^\d$/.test(key)) {
          e.preventDefault();
        }
        break;

      case 'phone':
        if (!/^\d$/.test(key)) {
          e.preventDefault();
        }
        break;

      case 'address':
        if (!/^[A-Za-z0-9\s\-#.,'/]$/.test(key)) {
          e.preventDefault();
        }
        break;

      default:
        break;
    }
  };

 const handleDateChange = (fieldName, value) => {
  setFormData((prev) => ({ ...prev, [fieldName]: value }));
  if (errors[fieldName] && value) {
    setErrors((prev) => ({ ...prev, [fieldName]: '' }));
  }
};

  const handleBlur = (fieldName, message = '') => {
    setTouchedFields((prev) => ({ ...prev, [fieldName]: true }));
    if (message) {
      setErrors((prev) => ({ ...prev, [fieldName]: message }));
    } else {
      setErrors((prev) => {
        const updated = { ...prev };
        delete updated[fieldName];
        return updated;
      });
    }
  };

  useEffect(() => {
    if (!open) {
      setFormData(prev => ({ ...prev, locationId: '' }));
    }
  }, [open]);

  const validate = () => {
    const tempErrors = {};

    if (!formData.locationId) {
      tempErrors.locationId = "Location is required";
    }

    Object.entries(formData).forEach(([key, value]) => {
      switch (key) {
        case 'firstName':
          if (!value || !value.trim()) {
            tempErrors[key] = 'First Name is required';
          } else if (value.length < 2) {
            tempErrors[key] = 'First Name must be at least 2 characters';
          } else if (value.length > fieldLimits.firstName) {
            tempErrors[key] = `First Name must not exceed ${fieldLimits.firstName} characters`;
          } else if (!patterns.namePattern.test(value)) {
            tempErrors[key] = 'First Name can only contain alphanumeric characters and spaces';
          }
          break;

        case 'middleName':
          if (value && value.trim()) {
            if (value.length > fieldLimits.middleName) {
              tempErrors[key] = `Middle Name must not exceed ${fieldLimits.middleName} characters`;
            } else if (!patterns.namePattern.test(value)) {
              tempErrors[key] = 'Middle Name can only contain alphanumeric characters and spaces';
            }
          }
          break;

        case 'lastName':
          if (!value || !value.trim()) {
            tempErrors[key] = 'Last Name is required';
          } else if (value.length < 2) {
            tempErrors[key] = 'Last Name must be at least 2 characters';
          } else if (value.length > fieldLimits.lastName) {
            tempErrors[key] = `Last Name must not exceed ${fieldLimits.lastName} characters`;
          } else if (!patterns.namePattern.test(value)) {
            tempErrors[key] = 'Last Name can only contain alphanumeric characters and spaces';
          }
          break;

          case 'dateOfBirth':
          if (!value) {
            tempErrors[key] = 'Date of Birth is required';
          } else if (!/^\d{2}-\d{2}-\d{4}$/.test(value)) {
            tempErrors[key] = 'MM-DD-YYYY is required';
          } else {
            const birthDate = dayjs(value, "MM-DD-YYYY");
            if (!birthDate.isValid()) {
              tempErrors[key] = 'Enter a valid date';
            } else {
              const age = dayjs().diff(birthDate, 'year');
              if (age < 16) {
                tempErrors[key] = 'Customer must be at least 16 years old';
              } else if (age > 120) {
                tempErrors[key] = 'Please enter a valid date of birth';
              }
            }
          }
          break;

        case 'email':
          if (!value || !value.trim()) {
            tempErrors[key] = 'Email is required';
          } else if (value.length > fieldLimits.email) {
            tempErrors[key] = `Email must not exceed ${fieldLimits.email} characters`;
          } else if (!patterns.emailPattern.test(value)) {
            tempErrors[key] = 'Please enter a valid email address (e.g., user@domain.com)';
          } else if ((value.match(/@/g) || []).length > 1) {
            tempErrors[key] = 'Email can contain only one @ symbol';
          } else if (value.endsWith('@')) {
            tempErrors[key] = 'Email cannot end with @ symbol';
          }
          break;

        case 'phoneNumber': {
          const err = validateUSPhoneRaw10(formData.phoneNumber);
          if (err) tempErrors[key] = err;
          break;
        }


        case 'addressLine1':
          if (!value || !value.trim()) {
            tempErrors[key] = 'Address Line 1 is required';
          } else if (value.length < 5) {
            tempErrors[key] = 'Address Line 1 must be at least 5 characters';
          } else if (value.length > fieldLimits.addressLine1) {
            tempErrors[key] = `Address Line 1 must not exceed ${fieldLimits.addressLine1} characters`;
          } else if (!patterns.addressPattern.test(value)) {
            tempErrors[key] = 'Address Line 1 contains invalid characters';
          }
          break;

        case 'addressLine2':
          if (value && value.trim()) {
            if (value.length > fieldLimits.addressLine2) {
              tempErrors[key] = `Address Line 2 must not exceed ${fieldLimits.addressLine2} characters`;
            } else if (!patterns.addressPattern.test(value)) {
              tempErrors[key] = 'Address Line 2 contains invalid characters';
            }
          }
          break;

        case 'city':
          if (!value || !value.trim()) {
            tempErrors[key] = 'City is required';
          } else if (value.length < 2) {
            tempErrors[key] = 'City must be at least 2 characters';
          } else if (value.length > fieldLimits.city) {
            tempErrors[key] = `City must not exceed ${fieldLimits.city} characters`;
          } else if (!patterns.cityPattern.test(value)) {
            tempErrors[key] = 'City can only contain alphanumeric characters';
          }
          break;

        case 'state':
          if (!value || !value.trim()) {
            tempErrors[key] = 'State is required';
          }
          break;

        case 'zipCode':
          if (!value || !value.trim()) {
            tempErrors[key] = 'Zip Code is required';
          } else if (!patterns.zipPattern.test(value)) {
            tempErrors[key] = 'Zip Code must be exactly 5 digits';
          }
          break;

        default:
          break;
      }
    });

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  }

  const callbackfn = (res) => {
    setNewCustomer(res);
    if (res?.id) {
      dispatch(getSelectedCustomerDetails(res.id));
      dispatch(getCustomerDetailsByIdAction(res.id));
      dispatch(getCustomerDataAction(res.id));
      dispatch(getQuoteListDataAction(res.id));
      dispatch(getNotesListDataAction(res.id));
      dispatch(getTaskListDataAction(res.id));
    }
    setSearchPerformed(true);
    setShowCustomerData(true);
    setExpandedView(true);
  }

const handleSubmit = () => {
    setTabValue(0);


    const newTouchedFields = {};
    Object.keys(formData).forEach((field) => {
      newTouchedFields[field] = true;
    });
    setTouchedFields(newTouchedFields);

    if (validate()) {
      const payload = {
        ...formData,
        dateOfBirth: formData.dateOfBirth ? dayjs(formData.dateOfBirth).format("MM-DD-YYYY") : null,
        phoneNumber: toE164FromRaw10(formData.phoneNumber),
      };

      dispatch(saveCustomerAction(payload, callbackfn));

      setFormData({
        firstName: '',
        middleName: '',
        lastName: '',
        dateOfBirth: null,
        email: '',
        phoneNumber: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        zipCode: '',
        locationId: ''
      });

      setOpen(false);
    } else {
      console.log("Validation failed");
    }
  };

  const resetForm = () => {
    setFormData({
      firstName: '',
      middleName: '',
      lastName: '',
      dateOfBirth: null,
      email: '',
      phoneNumber: '',
      addressLine1: '',
      addressLine2: '',
      city: '',
      state: '',
      zipCode: '',
      locationId: ''
    });
    setErrors({});
  };

  return (
   <Dialog
      open={open}
      onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
          }
          handleClose(event, reason);
        }}
      maxWidth="md"
      fullWidth
      fullScreen={isMobile}
      disableScrollLock={true}
      PaperProps={{
        sx: {
          height: isMobile ? '70vh' : 'auto',
          maxHeight: isMobile ? '70vh' : '90vh',
          margin: 0,
          overflow: 'hidden',
          '& .MuiDialogContent-root': {
            overflowY: 'auto',
            padding: isMobile ? '16px' : '24px',
          },
        },
      }}
      sx={{
        '& .MuiDialog-container': {
          alignItems: 'flex-start',
        },
        '& .MuiPaper-root': {
          marginTop: isMobile ? '0px' : '40px',
        },
      }}
    >

      <DialogTitle sx={{
        position: 'sticky',
        top: 0,
        zIndex: 1,
        padding: isMobile ? '12px 16px' : '16px 24px'
      }}>
        Create Customer
      </DialogTitle>
      <DialogContent>
        <Box sx={{
          mt: 1,
          '& .MuiGrid-container': {
            alignItems: 'flex-start'
          },
          '& .MuiFormLabel-root': {
            fontSize: isMobile ? '0.875rem' : '1rem',
            marginBottom: '4px',
            display: 'block'
          },
          '& .MuiFormHelperText-root': {
            marginLeft: 0,
            marginRight: 0,
            marginTop: '4px'
          }
        }}>
          <Grid container spacing={isMobile ? 1 : 2}>
            <Grid item xs={12} sm={4}>
              <FormLabel sx={{fontFamily: "Poppins, sans-serif;", color: "#000000"}} htmlFor="firstName">First Name <span style={{ color: "red" }}>*</span></FormLabel>
              <TextField
                fullWidth
                id="firstName" 
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                onKeyDown={(e) => handleKeyDown(e, 'name')}
                error={!!errors.firstName}
                helperText={errors.firstName}
                inputProps={{ maxLength: fieldLimits.firstName }}
                size={isMobile ? "small" : "medium"}
                 sx={{
                  '& .MuiInputBase-root': {
                    height: isMobile ? '40px' : '55px',
                    fontSize: isMobile ? '0.875rem' : '1rem'
                  }
                }}
                FormHelperTextProps={{
                  style: {
                    color: "rgb(211, 47, 47)",
                    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                    fontWeight: 400,
                    fontSize: "0.75rem",
                    lineHeight: 1.66,
                    letterSpacing: "0.03333em",
                    textAlign: "left",
                    margin: "3px 14px 0px",
                    minHeight: "20px",
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormLabel sx={{fontFamily: "Poppins, sans-serif;", color: "#000000"}} htmlFor='middleName'>Middle Name</FormLabel>
              <TextField
                id="middleName"
                fullWidth
                name="middleName"
                value={formData.middleName}
                onChange={handleChange}
                onKeyDown={(e) => handleKeyDown(e, 'name')}
                error={!!errors.middleName}
                helperText={errors.middleName}
                inputProps={{ maxLength: fieldLimits.middleName }}
                size={isMobile ? "small" : "medium"}
                 sx={{
                  '& .MuiInputBase-root': {
                    height: isMobile ? '40px' : '55px',
                    fontSize: isMobile ? '0.875rem' : '1rem'
                  }
                }}
                FormHelperTextProps={{
                  style: {
                    color: "rgb(211, 47, 47)",
                    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                    fontWeight: 400,
                    fontSize: "0.75rem",
                    lineHeight: 1.66,
                    letterSpacing: "0.03333em",
                    textAlign: "left",
                    margin: "3px 14px 0px",
                    minHeight: "20px",
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormLabel sx={{fontFamily: "Poppins, sans-serif;", color: "#000000"}} htmlFor='lastName'>Last Name <span style={{ color: "red" }}>*</span></FormLabel>
              <TextField
                id='lastName'
                fullWidth
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                onKeyDown={(e) => handleKeyDown(e, 'name')}
                error={!!errors.lastName}
                helperText={errors.lastName}
                inputProps={{ maxLength: fieldLimits.lastName }}
                size={isMobile ? "small" : "medium"}
                 sx={{
                  '& .MuiInputBase-root': {
                    height: isMobile ? '40px' : '55px',
                    fontSize: isMobile ? '0.875rem' : '1rem'
                  }
                }}
                FormHelperTextProps={{
                  style: {
                    color: "rgb(211, 47, 47)",
                    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                    fontWeight: 400,
                    fontSize: "0.75rem",
                    lineHeight: 1.66,
                    letterSpacing: "0.03333em",
                    textAlign: "left",
                    margin: "3px 14px 0px",
                    minHeight: "20px",
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormLabel sx={{fontFamily: "Poppins, sans-serif;", color: "#000000"}} htmlFor='dateOfBirth'>Date of Birth <span style={{ color: "red" }}>*</span></FormLabel>

            <DatePickerField
              id="dateOfBirth"
              fieldName="dateOfBirth"
              formData={formData}
              handleDateChange={handleDateChange}
              handleBlur={handleBlur}
              touchedFields={touchedFields}
              fieldErrors={errors}
              size={isMobile ? "small" : "medium"}
              sx={{
                '& .MuiInputBase-root': {
                  height: isMobile ? '40px' : '55px',
                  fontSize: isMobile ? '0.875rem' : '1rem'

                }
              }}
                FormHelperTextProps={{
                  style: {
                    color: "rgb(211, 47, 47)",
                    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                    fontWeight: 400,
                    fontSize: "0.75rem",
                    lineHeight: 1.66,
                    letterSpacing: "0.03333em",
                    textAlign: "left",
                    margin: "3px 14px 0px",
                    minHeight: "20px",
                  }
                }}
            />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormLabel sx={{fontFamily: "Poppins, sans-serif;", color: "#000000"}} htmlFor='email'>Email <span style={{ color: "red" }}>*</span></FormLabel>
              <TextField
              id='email'
                fullWidth
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                error={!!errors.email}
                helperText={errors.email}
                inputProps={{ maxLength: fieldLimits.email, autoComplete: "email", }}
                size={isMobile ? "small" : "medium"}
                 sx={{
                  '& .MuiInputBase-root': {
                    height: isMobile ? '40px' : '55px',
                    fontSize: isMobile ? '0.875rem' : '1rem'
                  }
                }}
                FormHelperTextProps={{
                  style: {
                    color: "rgb(211, 47, 47)",
                    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                    fontWeight: 400,
                    fontSize: "0.75rem",
                    lineHeight: 1.66,
                    letterSpacing: "0.03333em",
                    textAlign: "left",
                    margin: "3px 14px 0px",
                    minHeight: "20px",
                  }
                }}
              />
            </Grid>
           <Grid item xs={12} sm={4}>
              <PhoneNumberField
                label="Phone Number"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={(e) => {
                 
                  const raw = digitsOnly(e.target.value).slice(0, 10);
                  setFormData((prev) => ({ ...prev, phoneNumber: raw }));
                  if (errors.phoneNumber) setErrors((prev) => ({ ...prev, phoneNumber: "" }));
                }}
                error={errors.phoneNumber}
                required
                size={isMobile ? "small" : "medium"}
                disabled={false}
                labelStyle={{ fontSize: 14, fontWeight: 400,mt:-0.5}}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <FormControl fullWidth error={!!errors.locationId}>
                <FormLabel sx={{fontFamily: "Poppins, sans-serif;", color: "#000000"}} htmlFor='location-select'>Select Location <span style={{ color: "red" }}>*</span></FormLabel>
                <Select
                  native
                  name="locationId"
                  id="location-select"
                  value={formData.locationId}
                  onChange={handleChange}
                  size={isMobile ? "small" : "medium"}
                  sx={{
                    '& .MuiInputBase-root': {
                      height: isMobile ? '40px' : '55px',
                      fontSize: isMobile ? '0.875rem' : '1rem'
                    }
                  }}
                >
                  <option value="" disabled>Select Location</option>
                  {get_location?.map((loc) => (
                    <option key={loc.locationId} value={loc.locationId}>
                      {loc.locationDescription}
                    </option>
                  ))}
                </Select>
                <FormHelperText>{errors.locationId || " "}</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormLabel sx={{fontFamily: "Poppins, sans-serif;", color: "#000000"}} htmlFor='addressLine1'>Address Line 1 <span style={{ color: "red" }}>*</span></FormLabel>
              <TextField
                fullWidth
                id='addressLine1'
                name="addressLine1"
                value={formData.addressLine1}
                onChange={handleChange}
                onKeyDown={(e) => handleKeyDown(e, 'address')}
                error={!!errors.addressLine1}
                helperText={errors.addressLine1}
                inputProps={{ maxLength: fieldLimits.addressLine1 }}
                size={isMobile ? "small" : "medium"}
                 sx={{
                  '& .MuiInputBase-root': {
                    height: isMobile ? '40px' : '55px',
                    fontSize: isMobile ? '0.875rem' : '1rem'
                  }
                }}
                FormHelperTextProps={{
                  style: {
                    color: "rgb(211, 47, 47)",
                    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                    fontWeight: 400,
                    fontSize: "0.75rem",
                    lineHeight: 1.66,
                    letterSpacing: "0.03333em",
                    textAlign: "left",
                    margin: "3px 14px 0px",
                    minHeight: "20px",
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormLabel sx={{fontFamily: "Poppins, sans-serif;", color: "#000000"}} htmlFor='addressLine2'>Address Line 2</FormLabel>
              <TextField
                id="addressLine2"
                fullWidth
                name="addressLine2"
                value={formData.addressLine2}
                onChange={handleChange}
                onKeyDown={(e) => handleKeyDown(e, 'address')}
                error={!!errors.addressLine2}
                helperText={errors.addressLine2}
                inputProps={{ maxLength: fieldLimits.addressLine2 }}
                size={isMobile ? "small" : "medium"}
                 sx={{
                  '& .MuiInputBase-root': {
                    height: isMobile ? '40px' : '55px',
                    fontSize: isMobile ? '0.875rem' : '1rem'
                  }
                }}
                FormHelperTextProps={{
                  style: {
                    color: "rgb(211, 47, 47)",
                    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                    fontWeight: 400,
                    fontSize: "0.75rem",
                    lineHeight: 1.66,
                    letterSpacing: "0.03333em",
                    textAlign: "left",
                    margin: "3px 14px 0px",
                    minHeight: "20px",
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4} sx={{
              marginTop: isMobile ? '8px' : '0px',
              paddingTop: '0 !important'
            }} >
              <FormLabel sx={{fontFamily: "Poppins, sans-serif;", color: "#000000"}} htmlFor='city'>City <span style={{ color: "red" }}>*</span></FormLabel>
             {/* --- replace the entire City Autocomplete block with this --- */}
              <Autocomplete
                id="city"
                options={cityOptions || []}
                // input should show only the city name
                getOptionLabel={(opt) => opt?.cityName || ""}
                // filter by what the user types
                filterOptions={(options, { inputValue }) => {
                  const q = (inputValue || "").toLowerCase();
                  if (!q) return options;
                  return options.filter(o =>
                    (o.cityName || "").toLowerCase().includes(q) ||
                    (o.stateCode || "").toLowerCase().includes(q)
                  );
                }}
                isOptionEqualToValue={(opt, val) =>
                  `${opt.cityName}-${opt.stateCode}` === `${val?.cityName}-${val?.stateCode}`
                }
                inputValue={formData.city || ""}
                value={selectedCity || null}
                onInputChange={(e, newInput) => {
                  setSelectedCity(null);
                  setFormData(prev => ({ ...prev, city: newInput || "" }));   // city only while typing
                  if (newInput) debouncedCitySearch(newInput);                // no stateCode here
                }}
                  onChange={(e, option) => {
                  if (!option) return;
                  // set both on explicit selection
                  setSelectedCity(option);
                  setFormData(prev => ({
                    ...prev,
                    city: option.cityName,
                    state: option.stateCode,    // <-- populate state here
                  }));
                  if (errors.city) setErrors(prev => ({ ...prev, city: "" }));
                }}

                freeSolo
                selectOnFocus={false}
                clearOnBlur={false}
                autoHighlight
                loading={cityLoading}
                // list items as "City, ST" while the input keeps only City
               renderOption={(props, option) => {
                  const uniqueKey = `${option.cityName}-${option.stateCode}-${option.id || ''}`;
                  return (
                    <li {...props} key={uniqueKey}>
                      {option.cityName}{option.stateCode ? `, ${option.stateCode}` : ""}
                    </li>
                  );
                }}

                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Start typing city name..."
                    error={!!errors.city}
                    helperText={errors.city || ""}
                    fullWidth
                    sx={{
                      "& fieldset": { borderColor: "#C1C1C1" },
                      "& .MuiInputBase-root": {
                        height: "52px",
                        backgroundColor: "#fff",
                        fontSize: "16px",
                        fontFamily: '"Poppins", sans-serif',
                      },
                      "& .MuiInputBase-input": { color: "#000" },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {cityLoading ? <CircularProgress size={18} sx={{ mr: 1 }} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={4} sx={{
              marginTop: isMobile ? '8px' : '0px',
              paddingTop: '0 !important'
            }}>
              <FormControl fullWidth error={!!errors.state}>
                <FormLabel sx={{fontFamily: "Poppins, sans-serif;", color: "#000000"}} htmlFor='state'>State <span style={{ color: "red" }}>*</span></FormLabel>
                <Select
                  id="state"
                  native
                  name="state"
                  value={formData.state}
                  onChange={(e) => {
                    handleChange(e);
                    if (errors.state) {
                      setErrors((prev) => ({ ...prev, state: '' }));
                    }
                  }}
                  inputProps={{
                    'aria-label': 'State',
                  }}
                  size={isMobile ? "small" : "medium"}
                  sx={{
                    '& .MuiInputBase-root': {
                      height: isMobile ? '40px' : '55px',
                      fontSize: isMobile ? '0.875rem' : '1rem'
                    }
                  }}
                >
                  <option value="" disabled>Select State</option>
                  {driverLicenseState.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </Select>
                {errors.state && (
                  <FormHelperText
                    sx={{
                      color: "rgb(211, 47, 47)",
                      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                      fontWeight: 400,
                      fontSize: "0.75rem",
                      lineHeight: 1.66,
                      letterSpacing: "0.03333em",
                      textAlign: "left",
                      margin: "3px 14px 0px",
                      minHeight: "20px",
                    }}
                  >
                    {errors.state}
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4} sx={{
              marginTop: isMobile ? '8px' : '0px',
              paddingTop: '0 !important'
            }}>
              <FormLabel sx={{fontFamily: "Poppins, sans-serif;", color: "#000000"}} htmlFor='zipCode'>Zip Code <span style={{ color: "red" }}>*</span></FormLabel>
              <TextField
                fullWidth
                id="zipCode"
                name="zipCode"
                value={formData.zipCode}
                onChange={handleChange}
                onKeyDown={(e) => handleKeyDown(e, 'zipCode')}
                error={!!errors.zipCode}
                helperText={errors.zipCode}
                inputProps={{ maxLength: 5 }}
                size={isMobile ? "small" : "medium"}
                 sx={{
                  '& .MuiInputBase-root': {
                    height: isMobile ? '40px' : '55px',
                    fontSize: isMobile ? '0.875rem' : '1rem'
                  }
                }}
                FormHelperTextProps={{
                    style: {
                      color: "rgb(211, 47, 47)",
                      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                      fontWeight: 400,
                      fontSize: "0.75rem",
                      lineHeight: 1.66,
                      letterSpacing: "0.03333em",
                      textAlign: "left",
                      margin: "3px 14px 0px",
                      minHeight: "20px",
                    }
                  }}
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions sx={{
        padding: isMobile ? '8px 16px' : '16px 24px',
        flexDirection: isMobile ? 'column-reverse' : 'row',
        gap: '8px',
        position: 'sticky',
        bottom: 0,
        backgroundColor: 'white',
        zIndex: 1,

      }}>
        <Button
          variant="outlined"
          onClick={() => {
            resetForm();
            setOpen(false);
          }}
          sx={{
            width: isMobile ? '100%' : 'auto',
            minWidth: '120px',
            height: isMobile ? '40px' : '55px', '&:focus': {
                  outline: '1px solid #E69C00',
                }, textTransform: 'none', fontSize: '15px',
          }}
          size={isMobile ? "small" : "medium"}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          sx={{
            width: isMobile ? '100%' : 'auto',
            minWidth: '120px',
            height: isMobile ? '40px' : '55px', '&:focus': {
                  outline: '2px solid #E69C00',
                }, textTransform: 'none', fontSize: '15px',
          }}
          size={isMobile ? "small" : "medium"}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateCustomer;